import { DATO_CONTENT_TYPE, getDatoContent } from '@services/bff-content-hub/datocms';
import { clientLogger } from '@services/logger/clientLogger';
import { ResponsiveImageType } from 'react-datocms';

export type TFlagIcon = 'truck' | 'bolt' | 'box-open' | 'tag' | string;

export type TProductFlag = {
  active: boolean;
  name: string;
  label: string;
  facet: string;
  icon: TFlagIcon;
  color: any;
  startDate: string;
  endDate: string;
  tooltip?: string;
  image?: {
    responsiveImage: ResponsiveImageType;
  };
};

type FlagSlot = {
  active: boolean;
  flags: Array<TProductFlag>;
};

type ExhibitionArea = {
  active: boolean;
  name: string;
  page: string;
  reference: string;
  slots: Array<FlagSlot>;
};

export type ExhibitionAreaGroup = {
  tree: Record<string, Record<string, ExhibitionArea>>;
};

const EMPTY_EXHIBITION_AREAS: ExhibitionAreaGroup = { tree: {} };

export async function getServerlessProductFlagsData(): Promise<ExhibitionAreaGroup> {
  try {
    const data = await getDatoContent<ExhibitionAreaGroup>({
      modelApiKey: 'appearance_product_flag_exhibition_area',
      type: DATO_CONTENT_TYPE.COLLECTION,
      id: 'data',
    });

    return data?.tree ? data : EMPTY_EXHIBITION_AREAS;
  } catch (e) {
    clientLogger.serviceRequestFailed('Failed to fetch product flags data from DatoCMS', {
      service: 'datocms',
      action: 'get_serverless_product_flags_data',
      context: { reason: e?.message, stack: e?.stack },
    });
    return EMPTY_EXHIBITION_AREAS;
  }
}
